module.exports = "/images/me.svg?5a2ed1119009c410d17ef483d88892d2";